import { fetch } from "@fishx/rest";
import message from "../../message";
import { InternalNamePath } from './interface';

export function toArray<T>(candidate?: T | T[] | false): T[] {
  if (candidate === undefined || candidate === false) return [];

  return Array.isArray(candidate) ? candidate : [candidate];
}

export function getFieldId(namePath: InternalNamePath, formName?: string): string | undefined {
  if (!namePath.length) return undefined;

  const mergedId = namePath.join('_');
  return formName ? `${formName}_${mergedId}` : mergedId;
}

// 请求远程数据源
export async function remoteSourceHandler (options, relates, values, locale) {
  if (options && options.url) {
    const { url, method = 'GET', params = {} } = options;
    let fetchUrl = url;
    if (url.indexOf('${value}') > -1) {
      const value = values[relates[0]];
      if (value === null || value === undefined || value === "") {
        return false;
      }
      fetchUrl = fetchUrl.replace('${value}', value);
    }
    try {
      const { data } = await fetch(fetchUrl, {
        method,
        data: { ...params },
      });
      if (data) {
        return data;
      }
      return [];
    } catch (error) {
      // message.error(locale.requestFail);
      return [];
    }
  }
  return options || [];
}

export function handleFieldSource(name: string, options: Array<any>, wrapForm: any) {
  wrapForm.setFieldSource({[name]: options });
  // const currentValue = wrapForm.getFieldValue(name);
  // const exit = options.findIndex(v => v.value === currentValue) > -1;
  // // 如果下拉数据源内不包含当前值，则清空当前值
  // if (!exit) {
  //   wrapForm.setFieldsValue({[name]: null});
  // }
}

export function cascadeHandler(wrapForm, allValues, allDependency, currentItem='') {
  function cascade(relates, inputs, output, defaultOutput, key, item) {
    let res = relates.some((v, i) => {
      if (inputs[i] === '*') {
        return !allValues[v];
      } else {
        if (allValues[v] && typeof allValues[v] === 'object') {
          let value = Array.isArray(allValues[v]) ? allValues[v] : Object.values(allValues[v]);
          const res = value.some(val => {
            return inputs[i].indexOf(val) !== -1;
          })
          return !res;
        } else {
          return inputs[i].indexOf(allValues[v]) === -1;
        }
      }
    });
    if (key === 'value') {
      wrapForm.setFieldValue({[item]: res ? defaultOutput : output});
    } 
    if (key === 'source') {
      const { locale = {} } = wrapForm.__INTERNAL__;
      if (res) {
        remoteSourceHandler(defaultOutput, relates, allValues, locale).then(res => {
          if (res) {
            handleFieldSource(item, res, wrapForm);
          }
        });
      } else {
        remoteSourceHandler(output, relates, allValues, locale).then(res => {
          if (res) {
            handleFieldSource(item, res, wrapForm);
          }
        });
      }
    } 
    if (key === 'disabled') {
      wrapForm.setFieldDisabled({[item]: res ? defaultOutput : output});
    } 
    if (key === 'visible') {
      wrapForm.setFieldVisible({[item]: res ? defaultOutput : output});
    }
    if (key === 'required') {
      wrapForm.setFieldRequired({[item]: res ? defaultOutput : output});
    }
    return !res;
  }

  Object.keys(allValues).forEach(item => {
    let dependency = allDependency[item];
    if (dependency) {
      Object.keys(dependency).forEach(key => {
        const dep = dependency[key];
        const { relates, inputs, output, defaultOutput, cases = [] } = dep;
        if ((currentItem && relates.indexOf(currentItem) !== -1) || !currentItem) {
          if (cases.length) {
            cases.some(v => {
              return cascade(relates, v.inputs, v.output, defaultOutput, key, item);
            });
          } else {
            cascade(relates, inputs, output, defaultOutput, key, item);
          }
        }
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/components/simple-form/utils/util.ts